import { HttpClient, JSON_STRING, clientName, baseUrl, MHTTPCL } from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../booking/services/booking-service";

export const CONTACTS_URL = '/contacts.pl';

export const ContactsService = {

  changePromoter:(value,promoter_id,contact_id)=>MHTTPCL.post(CONTACTS_URL,{
    action:"change_promoter",
    key	:"company_legalname",
    value:	value,
    promoter_id	:promoter_id,
    contact_id:	contact_id
  }),


  findBankDetails: (id) => {
    return HttpClient.get(CONTACTS_URL, {
      section: '',
      action: "payment_provider_data",
      contact_id: id
    });
  },
  findCustomFields: ({ contact_id }) => {
    return MHTTPCL.post(CONTACTS_URL, {
      external_id: contact_id,
      external_table: 'contacts',
      action: 'get_custom_data',
      section: '',
    })
  },
  saveBankDetails: (id, provider_name, provider_data) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'save_payment_provider_data',
    contact_id: id,
    payment_provider: provider_name,
    payment_provider_data: provider_data
  }),
  removeBankDetails: (id, provider_name) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'remove_payment_provider_data',
    contact_id: id,
    payment_provider: provider_name
  }),
  findContacts: ({
    start = 0
  } = {}) => HttpClient.post(CONTACTS_URL, {
    action: 'get_both_type_contacts',
    start,
    output: JSON_STRING
  }),
  findContactDetails: ({
    contact_id
  }) => HttpClient.get(CONTACTS_URL, {
    action: 'individual_details', //'company_details',
    contact_id,
  }),
  searchContacts: ({
    key
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'search_contact',
    key
  }),
  getAdvancedForm: () => HttpClient.get(CONTACTS_URL, {
    action: 'advanced_search_form'
  }),
  advancedSearch: (payload = createAdvancedSearchPayload()) => {
    return HttpClient.post(CONTACTS_URL, {
      ...payload,

      action: 'search_contact',
      is_advanced_search: 'display',
      group_name: 'Advanced Search Result'
    });
  },
  // https://dev.berlin3.com/berlin3/contacts.pl?
  // name=Bilbo&
  // city=&
  // country=&
  // postalcode=&
  // address=&
  // region=&
  // email=&
  // group_id=&
  // action=search_contact&
  // is_advanced_search=export&
  // group_name=Advanced+Search+Result
  exportAdvancedSearch: (payload = createAdvancedSearchPayload()) => HttpClient.get(CONTACTS_URL, {
    ...payload,

    action: 'search_contact',
    is_advanced_search: 'export',
    group_name: 'Advanced Search Result'
  }),
  createGroupSearch: (payload = createAdvancedSearchPayload()) => HttpClient.get(CONTACTS_URL, {
    ...payload,

    action: 'search_contact',
    is_advanced_search: 'create_group',
    group_name: 'Advanced Search Result'
  }),
  exportAdvancedSearchURL: (payload = createAdvancedSearchPayload()) => {
    let url = `${baseUrl}/${clientName}` + CONTACTS_URL;

    const finalURL = `${url}?${querystring.stringify({
      ...payload,

      action: 'search_contact',
      is_advanced_search: 'export',
      group_name: 'Advanced Search Result'
    })}`;
    return finalURL;
  },
  exportVCardURL: ({
    contact_id
  }) => {
    let url = `${baseUrl}/${clientName}` + CONTACTS_URL;

    const finalURL = `${url}?${querystring.stringify({
      action: 'company_export_vcard',
      contact_id,
    })}`;
    return finalURL;
  },
  duplicateContact: ({
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'duplicate_contact',
    contact_class: 'company',
    contact_id
  }),
  checkInvoiceRelation: ({
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'has_invoice_relation',
    contact_id
  }),
  removeCompanyContact: ({
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'remove_company_contact',
    contact_id
  }),
  findAccountingInfo: ({
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'accounting_info',
    output: JSON_STRING,
    contact_id,
  }),
  findInvoiceTab: ({
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'contact_invoice_tab',
    contact_id: contact_id
  }),
  updatePaymentProvider: ({
    kVal,
    value,
    key
  }) => HttpClient.post(MODIFICATION_URL, {
    name: 'payment_provider_data',
    table: 'contacts',
    modify_type: 'json',
    json_op: 'set',
    kVal,
    value,
    json_key: key
  }),
  checkVatIdFlag: ({
    vat_no,
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'check_vat_id_update_flag',
    type: 'contact',
    vat_no,
    contact_id,
  }),
  checkInvoiceVatIdFlag: ({
    vat_no,
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'check_vat_id_update_flag',
    type: 'invoice',
    vat_no,
    contact_id,
  })
}

export const createAdvancedSearchPayload = ({
  name,
  city,
  city_omit,
  country,
  country_omit,
  postalcode,
  address,
  region,
  region_omit,
  email,
  group_id,
  group_omit_id,
  is_venue,
  is_promoter,
  is_distr_account,
  is_roy_account,
  is_lic_account,
  is_promo_account,
}) => {
  return {
    name,
    city,
    city_omit,
    country,
    country_omit,
    postalcode,
    address,
    region,
    region_omit,
    email,
    group_id,
    group_omit_id,
    is_venue,
    is_promoter,
    is_distr_account,
    is_roy_account,
    is_lic_account,
    is_promo_account,
  }
}